import { Provider } from 'react-redux';
import { ThemeProvider } from '@celltrak/ui-components';

import { PagesRouter } from '../Session';
import createStore from '../store';

import styles from './App.module.scss';

const store = createStore();

const App = () => (
  <ThemeProvider theme="evv" className={styles.themeProvider}>
    <Provider store={store}>
      <PagesRouter />
    </Provider>
  </ThemeProvider>
);

export default App;
